import EventListingSection from "../../components/Events/EventListingSection";
import Page from "../../finwell/pages/Page";


const AllEventsPage = () => {

  return (
    <Page>
      <EventListingSection />
    </Page>

  )


}

export default AllEventsPage;